import { render, staticRenderFns } from "./StaticPage.vue?vue&type=template&id=d45bb222"
import script from "./StaticPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaticPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StaticPage.vue?vue&type=style&index=0&id=d45bb222&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports